export default __webpack_public_path__ + "static/media/p.66f83f9f.svg";